export default __webpack_public_path__ + "static/media/org_person_name.5191444b.svg";